package de.katoonerie.type

sealed interface Result<out T> {
    object Pending : Result<Nothing>
    object Error : Result<Nothing>
    data class Success<T>(val value: T) : Result<T>
}
